import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summary',
  standalone: true,
})
export class SummaryPipe implements PipeTransform {
  transform(
    value: any,
    arg?: number | 'all',
    limit = 25,
    trail = '...'
  ): string {
    if (value == null) {
      return '';
    }

    if (typeof arg !== 'number' && arg === 'all') {
      return value;
    } else if (arg !== undefined) {
      return value.length > arg ? value.substring(0, arg) + trail : value;
    } else {
      return value.length > limit ? value.substring(0, limit) + trail : value;
    }
  }
}
